import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { useState, useEffect } from "react";

export const useGetAllVideos = () => {
    const [data, setData] = useState(null)

    useEffect(() => {
        const storage = getStorage();
        getDownloadURL(ref(storage, 'allvideos.json'))
            .then((url) => {
                fetch(url)
                .then(response => response.json())
                .then(json => setData(json))
            })
            .catch((error) => {
                // Handle any errors
            });
    }, [])
    return { data }
}